module.exports = __webpack_public_path__ + "img/pickupdumping_parked.25eb2d90.svg";